import { Recall } from "@/Common/Api/Communications/Dto/Recall";
import { Individual } from "@/Common/Api/Individuals/Dto/Individual";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { Address } from "@/Common/Models/Contacts/Address";
import { Email } from "@/Common/Models/Contacts/Email";
import { GenderIdentity as GenderIdentityEnum } from "@/Common/Models/Individuals/Enums/GenderIdentity";
import { PreferredPronouns as PreferredPronounsEnum } from "@/Common/Models/Individuals/Enums/PreferredPronouns";
import { Person } from "@/Common/Models/Person/Person";

type Id = "Id";
type FirstName = "FirstName";
type LastName = "LastName";
type PreferredName = "PreferredName";
type PreferredPronouns = "PreferredPronouns";
type SpecifiedPreferredPronouns = "SpecifiedPreferredPronouns";
type Prefix = "Prefix";
type GenderIdentity = "GenderIdentity";
type GenderLookupId = "GenderLookupId";
type HealthCardNumber = "HealthCardNumber";
type HealthCardExpiryDate = "HealthCardExpiryDate";
type FileNumber = "FileNumber";
type Addresses = "Addresses";
type Emails = "Emails";
type Identifier1 = "Identifier1";
type Identifier2 = "Identifier2";
type Identifier3 = "Identifier3";
type SelectedCountryLookupId = "SelectedCountryLookupId";
type SelectedRegionLookupId = "SelectedRegionLookupId";
type AvailableCountryLookupIds = "AvailableCountryLookupIds";
type AvailableRegionLookupIds = "AvailableRegionLookupIds";
type CivicAddressEdit = "CivicAddressEdit";
type CityEdit = "CityEdit";
type PostalCodeEdit = "PostalCodeEdit";
type NAMEdit = "NAMEdit";
type NAMExpiryEdit = "NAMExpiryEdit";
type selectedHealthCardRegionLookupId = "selectedHealthCardRegionLookupId";
type DOB = "DOB";
type IsVIP = "IsVIP";
type UpcomingAppointment = "UpcomingAppointment";
type RelatedRecalls = "RelatedRecalls";
type FamilyDoctorId = "FamilyDoctorId";
type IsFamilyDoctorFoundElsewhere = "IsFamilyDoctorFoundElsewhere";
type IsFamilyDoctorNotSubscribed = "IsFamilyDoctorNotSubscribed";
type IsFamilyDoctorLoading = "IsFamilyDoctorLoading";
type FamilyDoctorRAMQMessage = "FamilyDoctorRAMQMessage";
type AvailablePrefixLookups = "AvailablePrefixLookups";
type SelectedPrefixLookupId = "SelectedPrefixLookupId";
type IsPostalCodeValid = "IsPostalCodeValid";
type IsNAMValid = "IsNAMValid";
type IsPatientDuplicate = "IsPatientDuplicate";
type DuplicatePatientContactIds = "DuplicatePatientContactIds";
type DuplicatePopupOpen = "DuplicatePopupOpen";

type Phone1Edit = "Phone1Edit";
type Phone1TypeLookupId = "Phone1TypeLookupId";
type Phone1ContactTypeLookupId = "Phone1ContactTypeLookupId";
type Phone1Extension = "Phone1Extension";
type IsPhone1Valid = "IsPhone1Valid";
type Phone1NotificationsEnabled = "Phone1NotificationsEnabled";

type Phone2Edit = "Phone2Edit";
type Phone2TypeLookupId = "Phone2TypeLookupId";
type Phone2ContactTypeLookupId = "Phone2ContactTypeLookupId";
type Phone2Extension = "Phone2Extension";
type IsPhone2Valid = "IsPhone2Valid";
type Phone2NotificationsEnabled = "Phone2NotificationsEnabled";

type EmailEdit = "EmailEdit";
type EmailTypeByLookup = "EmailTypeByLookup";
type IsEmailValid = "IsEmailValid";
type IsOkToContact = "IsOkToContact";
type EmailNotificationsEnabled = "EmailNotificationsEnabled";

type PreferredSpokenLanguageLookupId = "PreferredSpokenLanguageLookupId";

type representantEnabled = "representantEnabled";
type representantType = "representantType";
type representantRelationType = "representantRelationType";
type representantNAM = "representantNAM";
type representantNAMValid = "representantNAMValid";
type representantFirstName = "representantFirstName";
type representantLastName = "representantLastName";
type representantPersonSelected = "representantPersonSelected";

type motherLastName = "motherLastName";
type motherFirstName = "motherFirstName";

class IJPatientCreationModel {
    public Id: string;
    public FirstName: string;
    public LastName: string;
    public PreferredName: string;
    public PreferredPronouns: PreferredPronounsEnum;
    public SpecifiedPreferredPronouns: string;
    public Prefix: string;
    public GenderLookupId: string;
    public HealthCardNumber: string;
    public HealthCardExpiryDate: Date;
    public FileNumber: string;
    public GenderIdentity: GenderIdentityEnum;

    public Addresses: Address[];
    public Emails: Email[];
    public Identifier1: string;
    public Identifier2: string;
    public Identifier3: string;
    public SelectedCountryLookupId: string;
    public SelectedRegionLookupId: string;
    public AvailableCountryLookupIds: FlatLookupView[];
    public AvailableRegionLookupIds: FlatLookupView[];
    public CivicAddressEdit: string;
    public CityEdit: string;
    public PostalCodeEdit: string;
    public NAMEdit: string;
    public NAMExpiryEdit: Date;
    public DOB: Date;
    public IsVIP: boolean;
    public UpcomingAppointment: UpcomingAppointment;
    public RelatedRecalls: Recall[];
    public FamilyDoctorId: string;
    public IsFamilyDoctorFoundElsewhere: boolean;
    public IsFamilyDoctorNotSubscribed: boolean;
    public IsFamilyDoctorLoading: boolean;
    public FamilyDoctorRAMQMessage: string;
    public AvailablePrefixLookups: FlatLookupView[];
    public SelectedPrefixLookupId: string;
    public IsPostalCodeValid: boolean;
    public IsNAMValid: boolean;
    public IsPatientDuplicate: boolean;
    public DuplictaeList: Individual[];
    public DuplicatePopupOpen: boolean;

    // phone bizness
    // PhoneNumbers: PhoneNumber[];
    public Phone1Edit: string;
    public Phone1TypeLookupId: string;
    public Phone1ContactTypeLookupId: string;
    public Phone1Extension: string;
    public IsPhone1Valid: boolean;
    public Phone1NotificationsEnabled: boolean;

    public Phone2Edit: string;
    public Phone2TypeLookupId: string;
    public Phone2ContactTypeLookupId: string;
    public Phone2Extension: string;
    public IsPhone2Valid: boolean;
    public Phone2NotificationsEnabled: boolean;

    public EmailEdit: string;
    public IsEmailValid: boolean;
    public EmailTypeByLookup: string;
    public IsOkToContact: boolean;
    public PreferredSpokenLanguageLookupId: string;
    public EmailNotificationsEnabled: boolean;

    public representantEnabled: boolean;
    public representantRelationType: string;
    public representantType: string;
    public representantNAM: string;
    public representantNAMValid: boolean;
    public representantFirstName: string;
    public representantLastName: string;
    public representantPersonSelected: Person;

    public motherLastName: string;
    public motherFirstName: string;

    public selectedHealthCardRegionLookupId: string;

    public static getHealthCardRegionLookupId(model: IPatientCreationModel): string {
        return cacheStore.ClinicSettings.EnableHealthCardValidation
            ? model.get("selectedHealthCardRegionLookupId")
            : model.get("SelectedRegionLookupId");
    }
}

interface IPatientCreationModel {
    get(key: Id): string;
    set(key: Id, value: string): this;

    get(key: FirstName): string;
    set(key: FirstName, value: string): this;

    get(key: LastName): string;
    set(key: LastName, value: string): this;

    get(key: PreferredName): string;
    set(key: PreferredName, value: string): this;

    get(key: PreferredPronouns): PreferredPronounsEnum;
    set(key: PreferredPronouns, value: PreferredPronounsEnum): this;

    get(key: SpecifiedPreferredPronouns): string;
    set(key: SpecifiedPreferredPronouns, value: string): this;

    get(key: GenderIdentity): GenderIdentityEnum;
    set(key: GenderIdentity, value: GenderIdentityEnum): this;

    get(key: Prefix): string;
    set(key: Prefix, value: string): this;

    get(key: HealthCardNumber): string;
    set(key: HealthCardNumber, value: string): this;

    get(key: HealthCardExpiryDate): Date;
    set(key: HealthCardExpiryDate, value: Date): this;

    get(key: FileNumber): string;
    set(key: FileNumber, value: string): this;

    get(key: Addresses): Immutable.List<Address>;
    set(key: Addresses, value: Immutable.List<Address>): this;

    get(key: Emails): Immutable.List<Email>;
    set(key: Emails, value: Immutable.List<Email>): this;

    get(key: Identifier1): string;
    set(key: Identifier1, value: string): this;

    get(key: Identifier2): string;
    set(key: Identifier2, value: string): this;

    get(key: Identifier3): string;
    set(key: Identifier3, value: string): this;

    get(key: GenderLookupId): string;
    set(key: GenderLookupId, value: string): this;

    get(key: CivicAddressEdit): string;
    set(key: CivicAddressEdit, value: string): this;

    get(key: CityEdit): string;
    set(key: CityEdit, value: string): this;

    get(key: PostalCodeEdit): string;
    set(key: PostalCodeEdit, value: string): this;

    get(key: NAMEdit): string;
    set(key: NAMEdit, value: string): this;

    get(key: NAMExpiryEdit): Date;
    set(key: NAMExpiryEdit, value: Date): this;

    get(key: selectedHealthCardRegionLookupId): string;
    set(key: selectedHealthCardRegionLookupId, value: string): this;

    get(key: IsVIP): boolean;
    set(key: IsVIP, value: boolean): this;

    get(key: DOB): Date;
    set(key: DOB, value: Date): this;

    get(key: UpcomingAppointment): UpcomingAppointment;
    set(key: UpcomingAppointment, value: UpcomingAppointment): this;

    get(key: RelatedRecalls): Immutable.List<Recall>;
    set(key: RelatedRecalls, value: Immutable.List<Recall>): this;

    get(key: FamilyDoctorId): string;
    set(key: FamilyDoctorId, value: string): this;

    get(key: IsFamilyDoctorFoundElsewhere): boolean;
    set(key: IsFamilyDoctorFoundElsewhere, value: boolean): this;

    get(key: IsFamilyDoctorNotSubscribed): boolean;
    set(key: IsFamilyDoctorNotSubscribed, value: boolean): this;

    get(key: IsFamilyDoctorLoading): boolean;
    set(key: IsFamilyDoctorLoading, value: boolean): this;

    get(key: FamilyDoctorRAMQMessage): string;
    set(key: FamilyDoctorRAMQMessage, value: string): this;

    get(key: AvailablePrefixLookups): Immutable.List<FlatLookupView>
    set(key: AvailablePrefixLookups, value: Immutable.List<FlatLookupView>): this;

    get(key: SelectedPrefixLookupId): string;
    set(key: SelectedPrefixLookupId, value: string): this

    get(key: AvailableCountryLookupIds): Immutable.List<FlatLookupView>
    set(key: AvailableCountryLookupIds, value: Immutable.List<FlatLookupView>): this;

    get(key: SelectedCountryLookupId): string;
    set(key: SelectedCountryLookupId, value: string): this;

    get(key: AvailableRegionLookupIds): Immutable.List<FlatLookupView>
    set(key: AvailableRegionLookupIds, value: Immutable.List<FlatLookupView>): this;

    get(key: SelectedRegionLookupId): string;
    set(key: SelectedRegionLookupId, value: string): this;

    get(key: IsPostalCodeValid): boolean;
    set(key: IsPostalCodeValid, value: boolean): this;

    get(key: IsNAMValid): boolean;
    set(key: IsNAMValid, value: boolean): this;

    get(key: IsPatientDuplicate): boolean;
    set(key: IsPatientDuplicate, value: boolean): this;

    get(key: DuplicatePatientContactIds): Immutable.List<string>;
    set(key: DuplicatePatientContactIds, value: Immutable.List<string>): this;

    get(key: DuplicatePopupOpen): boolean;
    set(key: DuplicatePopupOpen, value: boolean): this;

    get(key: Phone1Edit): string;
    set(key: Phone1Edit, value: string): this;

    get(key: Phone1TypeLookupId): string;
    set(key: Phone1TypeLookupId, value: string): this;

    get(key: Phone1ContactTypeLookupId): string;
    set(key: Phone1ContactTypeLookupId, value: string): this;

    get(key: Phone1Extension): string;
    set(key: Phone1Extension, value: string): this;

    get(key: IsPhone1Valid): boolean;
    set(key: IsPhone1Valid, value: boolean): this;

    get(key: Phone1NotificationsEnabled): boolean;
    set(key: Phone1NotificationsEnabled, value: boolean): this;

    get(key: Phone2Edit): string;
    set(key: Phone2Edit, value: string): this;

    get(key: Phone2TypeLookupId): string;
    set(key: Phone2TypeLookupId, value: string): this;

    get(key: Phone2ContactTypeLookupId): string;
    set(key: Phone2ContactTypeLookupId, value: string): this;

    get(key: Phone2Extension): string;
    set(key: Phone2Extension, value: string): this;

    get(key: IsPhone2Valid): boolean;
    set(key: IsPhone2Valid, value: boolean): this;

    get(key: Phone2NotificationsEnabled): boolean;
    set(key: Phone2NotificationsEnabled, value: boolean): this;

    get(key: EmailEdit): string;
    set(key: EmailEdit, value: string): this;

    get(key: IsEmailValid): boolean;
    set(key: IsEmailValid, value: boolean): this;

    get(key: EmailTypeByLookup): string;
    set(key: EmailTypeByLookup, value: string): this;

    get(key: IsOkToContact): boolean;
    set(key: IsOkToContact, value: boolean): this;

    get(key: EmailNotificationsEnabled): boolean;
    set(key: EmailNotificationsEnabled, value: boolean): this;

    get(key: PreferredSpokenLanguageLookupId): string;
    set(key: PreferredSpokenLanguageLookupId, value: string): this;

    get(key: representantEnabled): boolean;
    set(key: representantEnabled, value: boolean): this;

    get(key: representantRelationType): string;
    set(key: representantRelationType, value: string): this;

    get(key: representantType): string;
    set(key: representantType, value: string): this;

    get(key: representantNAM): string;
    set(key: representantNAM, value: string): this;

    get(key: representantNAMValid): boolean;
    set(key: representantNAMValid, value: boolean): this;

    get(key: representantFirstName): string;
    set(key: representantFirstName, value: string): this;

    get(key: representantLastName): string;
    set(key: representantLastName, value: string): this;

    get(key: representantPersonSelected): Person;
    set(key: representantPersonSelected, value: Person): this;

    get(key: representantFirstName): string;
    set(key: representantFirstName, value: string): this;

    get(key: motherLastName): string;
    set(key: motherLastName, value: string): this;

    get(key: motherFirstName): string;
    set(key: motherFirstName, value: string): this;
}

export { IJPatientCreationModel, IPatientCreationModel };
